import { showLogoutAlert } from "./show_notification";
let logoutTimer;
let alertTimer;
const isLoginPage = () => {
  const onLoginPage = window.location.pathname === '/login';
  if (onLoginPage) {
    clearTimers();
  }
  return onLoginPage;
};

const clearTimers = () => {
  clearTimeout(logoutTimer);
  clearTimeout(alertTimer);
};

export const initLogoutTimer = () => {
  clearTimers();
  if (isLoginPage()) return;
  logoutTimer = setTimeout(() => {
    window.location.replace('/logout');
  }, 3600000); // 60 minutes 
  // }, 20000); // 20 seconds 

  alertTimer = setTimeout(() => {
    showLogoutAlert()
// showNotification("You have been idle for 40 minutes.","Warning")
  }, 2400000); // 40 minutes
  // }, 10000); // 10 seconds
};

export const resetLogoutTimer = () => {
  if (isLoginPage()) return;
  clearTimers();
  initLogoutTimer();
};